// React hooks
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Helpers i API servisi
import { useTranslate } from "helpers";

// Tipovi i konstante
import { VehicleInvoiceSearchPageCmp, VehicleInvoiceSearchPageProps } from "./types";
import { FLEET_VEHICLE_INVOICE_SEARCH_PAGE_TITLE } from "ui/components/PageTitle/consts";

// UI komponente
import { Tabs } from "ui/components/Tabs";

// Moduli specifični za projekt
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";

// Lokalne komponente
import { initialFleetVehicleDetailForm } from "services/api/fleet/vehicles/consts";
import { FleetVehicleDetailFormValues } from "services/api/fleet/vehicles/types";
import { getFleetVehicleAPI } from "services/api/fleet/vehicles/api";
import { Errors } from "services/forms/validation/types";
import TabMenu from "ui/modules/fleet/vehicles/pages/components/TabMenu/TabMenu";
import { VehicleTabHeader } from "ui/modules/fleet/vehicles/pages/components/VehicleTabHeader";
import VehicleInvoiceSaleSearchTab from "./components/VehicleInvoiceSaleSearchTab/VehicleInvoiceSaleSearchTab";
import VehicleInvoiceRentSearchTab from "./components/VehicleInvoiceRentSearchTab/VehicleInvoiceRentSearchTab";
import VehicleInvoiceIncomingSearchTab from "./components/VehicleInvoiceIncomingSearchTab/VehicleInvoiceIncomingSearchTab";


const VehicleInvoiceSearchPage: VehicleInvoiceSearchPageCmp = (
  props: VehicleInvoiceSearchPageProps
) => {

  const { id } = useParams();
  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<FleetVehicleDetailFormValues>(
    initialFleetVehicleDetailForm
  );

  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (id) {
      fetchVehicle(id);
    }
  }, [id]);

  const fetchVehicle = async (id: string) => {
    if (id === undefined) {
      setFormValues(initialFleetVehicleDetailForm);
      return;
    }

    setIsLoading(true);

    let result;
    try {
      result = await getFleetVehicleAPI(id);
    } catch {
      setIsLoading(false);
      return;
    }

    setFormValues(result);
    setIsLoading(false);

    setErrors({});
  };

  // Promjena statusa preko značke — vozilo se dohvaća ponovno da se značka osvježi.
  const handleStatusChange = useCallback(() => {
    if (id) fetchVehicle(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!id) return <></>;

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <VehicleTabHeader
            vehicleId={id}
            vehicle={formValues}
            title={t(FLEET_VEHICLE_INVOICE_SEARCH_PAGE_TITLE.text)}
            icon={FLEET_VEHICLE_INVOICE_SEARCH_PAGE_TITLE.icon}
            iconColor={FLEET_VEHICLE_INVOICE_SEARCH_PAGE_TITLE.iconColor}
            onStatusChange={handleStatusChange}
          />
        </div>
        <TabMenu vehicleId={id} />
        <div className="py-3 px-4">
          <Tabs
            tabs={[
              {
                label: "Izlazni računi",
                queryParam: "outgoing",
                content: (
                  <div className="px-0 pt-6 pb-8 mx-[-1px] mt-[-1px] xl:px-6 border">
                    <Tabs
                      variant="pill"
                      queryParamName="subtab"
                      tabs={[
                        {
                          label: "Prodaja vozila",
                          queryParam: "sale",
                          content: (
                            <div>
                              <VehicleInvoiceSaleSearchTab />
                            </div>
                          ),
                        },
                        {
                          label: "Najam vozila",
                          queryParam: "rent",
                          content: (
                            <div>
                              <VehicleInvoiceRentSearchTab />
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                ),
              },
              {
                label: "Ulazni računi",
                queryParam: "incoming",
                content: (
                  <div>
                    <VehicleInvoiceIncomingSearchTab />
                  </div>
                ),
              },
            ]}
          />
        </div>
      </div>

    </>
  );
};

VehicleInvoiceSearchPage.route = FleetVehicleRoutes.FleetVehicleInvoiceSearchPageRouter;

export default VehicleInvoiceSearchPage;
